<template>
  <div class="pop">
    <div class="wrap">
      <div class="title">创建试卷</div>
      <div class="middle">
        <div @click="$router.push('/manage/normalpaper')">
          <img src="../../assets/paper/paper1.png" alt="">
        </div>
        <div @click="$router.push('/manage/selectpaper')">
          <img src="../../assets/paper/paper2.png" alt="">
        </div>
        <div @click="$router.push('/manage/radompaper')">
          <img src="../../assets/paper/paper3.png" alt="">
        </div>
      </div>
      <div class="bottom">
           <div class="buttom" @click="close">
             关闭
           </div>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      model1: null,
      model2: null
    };
  },
  methods:{
    close(){
      this.$emit("close")
    }
  }
};
</script>
<style lang="css" scoped>
.pop {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.1);
  z-index: 1000;
  width: 100%;
  height: 100%;
}
.wrap {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 8.73rem;
  height:4.3rem;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 10px;
  padding:0.24rem;
}
.title{
  font-size: 0.22rem;
}
.middle{
  margin-top: 0.8rem;
  display: flex;
  justify-content: space-between;
}
.middle>div{
  width: 2.5rem;
}
.middle img{
  width: 100%;
  transition: all 0.2s;
  cursor: pointer;
}
.middle img:hover{
  transform: scale(1.2)
}
.bottom{
  margin: 0.4rem;
}
.buttom{
    height: 0.3rem;
    width: 1rem;
    display: inline-block;
    background: #5b48ff;
    color: #fff;
    font-size: 0.14rem;
    border-radius: 2px;
    line-height: 0.3rem;
}
</style>


// WEBPACK FOOTER //
// src/components/toast/creatpapertype.vue